<template>
  <div>

    <v-dialog width="600px" v-model="infoDialog">
      <v-card>
        <v-card-title>
          <div class="d-flex flex-column justify-center ml-2">
            <img src="../../assets/icons/menu/info-circle-black.svg" alt="" />
          </div>
          <div style="font-family: bold !important">
            <div>{{ $t("sessionCard.info_title") }}</div>
          </div>
          <div class="flex-grow-1 text-left">
            <div class="d-flex justify-end">
              <v-icon @click="infoDialog = false" color="black"
                >mdi-close</v-icon
              >
            </div>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="">
            <div class="moreInfo" style="font-size: 15px">
              <div>{{ $t("sessionCard.info_intro") }}</div>
            </div>
            <ul
              class="mr-6 mt-3"
              style="font-size: 15px; color: #424242; line-height: 25pt"
            >
              <li>
                {{ $t("sessionCard.info_1") }}
              </li>
              <li>
                {{ $t("sessionCard.info_2") }}
              </li>
              <li>
                {{ $t("sessionCard.info_3") }}
              </li>
              <li>
                {{ $t("sessionCard.info_4") }}
              </li>
              <li>
                {{ $t("sessionCard.info_5") }}
              </li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div
      v-if="session.is_presession && session.state == 'date_fixed'"
      class="mt-5"
    >
      <div class="preSessionBox">
        <div class="headerSessionCard d-flex">
          <div class="imgBox d-flex justify-center flex-column">
            <img
              :src="session.doctor.avatar"
              style="border-radius: 100%"
              width="30px"
              alt=""
            />
          </div>
          <div class="doctorData flex-grow-1">
            <div class="titleDoctorData ml-2">
              {{ $t("newPreSession.evaluationSpecialist") }}
            </div>
            <div class="DoctorDataValue ml-2">
              {{
                $vuetify.rtl
                  ? session.doctor.full_name
                  : session.doctor.en_name + " " + session.doctor.en_family
              }}
            </div>
          </div>
          <div class="callToAction"></div>
        </div>
        <div
          class="counterSession d-flex justify-center flex-column justify-center"
        >
          <div class="d-flex">
            <div class="d-flex justify-center flex-column">
              <img src="../../assets/icons/menu/timer.gif" width="24" alt="" />
            </div>
            <div class="counterSessionValue d-flex justify-center flex-column title-medium-20">
              {{ $vuetify.rtl ? diff : $t("sessionCard.countdown") }}
              {{ !$vuetify.rtl ? diff : $t("sessionCard.countdown") }}
            </div>
          </div>
        </div>
        <div class="sessionDate mt-6">
          <v-row>
            <v-col cols="12" lg="3">
              <div class="sessionDateItem">
                <div class="sessionDateItemImage">
                  <img src="../../assets/icons/menu/calendar.svg" alt="" />
                </div>
                <div v-if="$vuetify.rtl" class="sessionDateItemText">
                  {{ session.fixed_date_day }}
                  ،
                  {{ session.fixed_date_time_g | sessionDate }}
                  <!--                  19 فروردین 1402-->
                </div>
                <div v-else>
                  {{gregorianDate}}
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="3">
              <div class="sessionDateItem">
                <div class="sessionDateItemImage">
                  <img src="../../assets/icons/menu/clock.svg" alt="" />
                </div>
                <div class="sessionDateItemText">
                  {{ session.fixed_time }}
                  ({{ profile.tz }})
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="3">
              <div class="sessionDateItem">
                <div class="sessionDateItemImage">
                  <img
                    src="../../assets/icons/menu/monitor_active.svg"
                    alt=""
                  />
                </div>
                <div class="sessionDateItemText">
                  {{ $t("newPreSession.evaluationSession") }}
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
        <div
          class="actionArea d-flex"
          :class="$vuetify.breakpoint.mdAndDown && 'flex-column'"
          style="margin-top: 24px"
        >
          <div class="">
            <a :href="session.doctor.skype_link" target="_blank">
              <v-btn
                :disabled="!session.can_enter"
                class="white--text"
                style="text-transform: none;border-radius: 8px !important"
                :style="
                  $vuetify.breakpoint.mdAndUp ? 'width:200px' : 'width:100%'
                "
                 color="#39C990"
                elevation="0"
              >
                {{ $t('sessionCard.session_link') }}
              </v-btn>
            </a>
          </div>
          <div class="">
            <a :href="url" target="_blank">
              <v-btn
                :class="[$vuetify.breakpoint.mdAndUp ? 'mr-3' : 'mt-2',$vuetify.rtl ? '' : 'ml-lg-3']"
                outlined
                :style="
                  $vuetify.breakpoint.mdAndUp ? 'width:200px' : 'width:100%'"
                 style="text-transform: none;border-radius: 8px !important"
                color="#39C990"
                elevation="0"
              >
                {{ $t('sessionCard.add_to_calendar') }}
              </v-btn>
            </a>
          </div>
        </div>
        <div
          class="moreInfo"
          style="margin-top: 16px"
          @click="infoDialog = true"
        >
          <div class="d-flex justify-space-between">
            <div>
              {{ $t('sessionCard.info_link_text') }}
            </div>
            <div>
              <img src="../../assets/icons/menu/info-circle.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="sessionCard mt-5"
      :class="session.state == 'used' && 'usedSession'"
    >
      <div class="d-flex flex-column justify-space-around fill-height">
        <!--        <div v-if="session.state == 'doctor_assigned'">-->
        <!--          <SelectTimeSessionCard @nextHandler="nextHandler" :session-i-d="session.id"/>-->
        <!--        </div>-->
        <div class="sessionCardTitle">
          <div class="d-flex justify-end flex-wrap">
            <template v-if="session.reason == 'other'">
              <div
                class="timeArea d-flex flex-row"
                dir="ltr"
                v-if="session.state != 'doctor_assigned'"
              >
                <div class="">
                  <!--                {{ session.fixed_date }}-->
                  {{ session.fixed_date_day }}
                </div>
                <div
                  style="width: 1px; height: 25px; background: black"
                  class="mx-2"
                ></div>
                <div class="en_light">
                  {{ gorgianFilter(session.fixed_date_time_g) }}
                </div>
                <div
                  style="width: 1px; height: 25px; background: black"
                  class="mx-2"
                ></div>
                <div>
                  {{ timeFilter(session.fixed_date_time) }}

                  ({{ profile.tz }})
                </div>
              </div>
            </template>
            <template v-else-if="session.reason == 'extra_session_time'">
              <div
                class="timeArea d-flex flex-row"
                dir="ltr"
                v-if="session.state != 'doctor_assigned'"
              >
                <div class="">
                  <!--                {{ session.fixed_date }}-->
                  {{ session.fixed_date_day }}
                </div>
                <div
                  style="width: 1px; height: 25px; background: black"
                  class="mx-2"
                ></div>
                <div class="en_light">
                  {{ gorgianFilter(session.fixed_date_time_g) }}
                </div>
                <div
                  style="width: 1px; height: 25px; background: black"
                  class="mx-2"
                ></div>
                <div>
                  {{ timeFilter(session.fixed_date_time) }}

                  ({{ profile.tz }})
                </div>
              </div>
              <v-chip color="primary mt-2" x-small>{{ $t('sessionCard.missing_time') }}</v-chip>
            </template>
            <template v-else>
              <div class="">
                <v-chip color="primary" small>{{ $t('sessionCard.extra_time') }} </v-chip>
              </div>
            </template>
          </div>
        </div>
        <div>
          <div
            class="sessionCardInfo d-flex justify-space-between"
            :class="$vuetify.breakpoint.mdAndDown && 'flex-column'"
          >
            <div class="mt-4 therapistName">
              <!--            <span style="color:#4597DF;">-->
              <!--              {{ $t('sessionCard.therapist_name') }}-->
              <!--            </span>-->
              <!--              <span v-if="session.hasOwnProperty('doctor')">-->
              <!--              {{ session.doctor.full_name }}-->
              <!--            </span>-->
              <div class="therapistImage d-flex">
                <div>
                  <img :src="session.doctor.avatar" alt="" />
                  <br />
                  <div class="text-center" v-if="!session.is_presession">
                    <v-btn
                      text
                      x-small
                      class=""
                      color="#3CBE8B"
                      elevation="0"
                      :href="session.doctor.resume_link"
                      target="_blank"
                    >
                      {{ $t('sessionCard.show_resume') }}
                    </v-btn>
                  </div>
                </div>
                <div class="d-flex flex-column justify-center mr-2">
                  <div>
                    <span style="color: #4597df">
                      <template v-if="!session.is_presession">
                          {{ $t('sessionCard.therapist_label') }}
                      </template>
                    </span>
                    {{ session.doctor.full_name }}
                  </div>
                  <div>
                    <v-btn
                      class="mt-2"
                      small
                      outlined
                      color="primary"
                      v-if="session.doctor.hasOwnProperty('skype_link')"
                      :href="session.doctor.skype_link"
                      target="_blank"
                    >
                      {{ $t('sessionCard.skype_link') }}
                      <v-icon class="mx-1">mdi-skype</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
            <div class="">
              <div class="statusLabel">
                <div class="actionArea d-flex mt-3 justify-end">
                  <template v-if="session.state === 'doctor_assigned'">
                    <div class="ml-2">  {{ $t('sessionCard.request_session') }}
                    </div>
                    <img
                      width="23px"
                      height="23px"
                      :class="!$vuetify.rtl && 'en_arrow'"
                      src="../../assets/image/png/session/button_status.png"
                      style="border-radius: 5px"
                      alt=""
                    />
                  </template>
                  <div class="d-flex" v-if="session.state === 'used'">
                    <div class="ml-2">
                      {{ $t("sessionCard.used") }}
                      <template
                        v-if="
                          !session.is_presession &&
                          session.reason != 'extra_session_time'
                        "
                      >
                        <span @click="downloadFactor" style="cursor: pointer">
                          - {{ $t('sessionCard.download_invoice') }}
                        </span>
                      </template>
                    </div>
                    <img
                      :class="!$vuetify.rtl && 'en_arrow'"
                      src="../../assets/image/png/session/buy.png"
                      v-if="!session.is_presession"
                      style="border-radius: 5px; transform: rotate(-90deg)"
                      width="23px"
                      height="23px"
                      alt=""
                    />
                    <img
                      :class="!$vuetify.rtl && 'en_arrow'"
                      src="../../assets/image/png/session/buy.png"
                      v-else
                      style="border-radius: 5px"
                      width="23px"
                      height="23px"
                      alt=""
                    />
                  </div>
                  <template v-else-if="session.state === 'date_fixed'">
                    <template v-if="session.can_enter">
                      <div class="ml-2">
                        {{ $t("sessionCard.can_enter") }}
                      </div>
                      <img
                        width="23px"
                        height="23px"
                        :class="!$vuetify.rtl && 'en_arrow'"
                        src="../../assets/image/png/session/button_status.png"
                        style="border-radius: 5px"
                        alt=""
                      />
                    </template>
                    <template v-else>
                      <div class="ml-2">
                        {{ $t("sessionCard.date_fixed") }}
                      </div>
                      <img
                        width="23px"
                        height="23px"
                        :class="!$vuetify.rtl && 'en_arrow'"
                        src="../../assets/image/png/session/button_status.png"
                        style="border-radius: 5px"
                        alt=""
                      />
                    </template>
                  </template>
                  <div></div>
                </div>
                <div
                  class="mt-4 font-weight-bold"
                  style="font-size: 14px"
                  v-if="
                    session.state === 'date_fixed' &&
                    !session.can_enter &&
                    session.is_presession
                  "
                >
                   {{ $t('sessionCard.reminder_call') }}

                </div>
                <template v-if="session.is_presession">
                  <div class="preSessionBadge">{{ $t('sessionCard.presession') }}</div>
                  <!--                  <div class="text-left ">-->
                  <!--                    <v-chip color="primary" small class="mt-5">پیش مشاوره</v-chip>-->
                  <!--                  </div>-->
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import moment from "moment-jalaali";
import momentG from "moment"
import momentTz from "moment-timezone";
import { mapGetters } from "vuex";
import SelectTimeSessionCard from "@/components/Sessions/SelectTimeSessionCard";
import SessionMixins from "@/mixins/SessionMixins";
import momentJalali from "moment-jalaali";

export default {
  components: { SelectTimeSessionCard },
  computed: {
    ...mapGetters({
      profile: "getProfile",
    }),
    url() {
      return `https://www.google.com/calendar/render?action=TEMPLATE&text=${this.$t('sessionCard.presession')}جلسه پیش‌مشاوره&dates=${this.start}/${this.end}&details=Event%20Description&location=Event%20Location`;
    },
  },
  data() {
    return {
      infoDialog: false,
      start: null,
      end: null,
      diff: null,
      gregorianDate : null
    };
  },
  mixins: [SessionMixins],
  props: {
    session: Object,
  },
  mounted() {
    if (this.session.is_presession) {
      this.calcDiff();
      setInterval(() => {
        this.calcDiff();
      }, 1000);
    }

    this.start =
      momentTz
        .tz(
          this.session.fixed_date_time_g,
          "YYYY-MM-DD HH:mm:ss",
          this.profile.tz
        )
        .utc()
        .format("YYYYMMDDTHHmmss") + "Z";
    this.end =
      momentTz
        .tz(this.session.to_date_time_g, "YYYY-MM-DD HH:mm:ss", this.profile.tz)
        .utc()
        .format("YYYYMMDDTHHmmss") + "Z";

    const fixedG = this.session.fixed_date_time_g;


    moment.loadPersian({ usePersianDigits: false });

    this.gregorianDate = moment(fixedG).locale('en').format('dddd, MMMM D, YYYY');

  },
  methods: {
    calcDiff() {
      const targetTime = moment(this.session.fixed_date_time_g);

      // Current time
      const now = moment();

      // Calculate duration
      const duration = moment.duration(targetTime.diff(now));

      // Format duration as HH:mm:ss
      const hours = Math.floor(Math.abs(duration.asHours()))
        .toString()
        .padStart(2, "0");
      const minutes = Math.abs(duration.minutes()).toString().padStart(2, "0");
      const seconds = Math.abs(duration.seconds()).toString().padStart(2, "0");
      this.diff = `${hours}:${minutes}:${seconds}`;
    },
    convertTZ(time, tz) {
      var current = momentTz.tz(time, tz);
      return current.clone().utc();
    },
    downloadFactor() {
      this.$emitEvent("setLoading", true);
      this.AxiosWithDownload(
        `user/sessions/${this.session.id}/factor`,
        `session_${this.session.id}_factor`,
        "pdf"
      )
        .then(() => {
          this.$emitEvent("notify", {
            title: this.$t("sessionCard.download_starting"),
            color: "green",
          });
        })
        .finally(() => {
          this.$emitEvent("setLoading", false);
        });
    },
    nextHandler() {
      this.$emitEvent("notify", {
        color: "green",
        title: this.$t("sessionCard.scheduled_success"),
      });
      this.$emit("getAllSession");
    },
    gorgianFilter(date) {
      return (
        moment(date).format("dddd") + " " + moment(date).format("YYYY/MM/DD")
      );
    },
    timeFilter(date) {
      return moment(date).format("HH:mm");
    },
  },
  filters: {
    sessionDate(date) {
      momentJalali.loadPersian({ usePersianDigits: false });
      return momentJalali(date).format("jD jMMMM jYYYY");
    },
  },
};
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 600px) {
  .preSessionBox {
    width: 100% !important;
    margin: 0px auto;
  }

  .titleSession {
    font-size: 14px !important;
  }

  .sessionCard {
    padding: 10px !important;
  }

  .timeArea {
    width: 100%;
    font-size: 11px !important;
    justify-content: space-between !important;
  }

  .therapistName {
    font-size: 12px;
  }

  .actionArea {
    font-size: 12px !important;
  }

  .preSessionBadge {
    width: 90px !important;
    font-size: 12px !important;
    top: 8px !important;
  }
}

.moreInfo {
  cursor: pointer;
  border-top: 1px solid #eaf0f6;
  padding-top: 16px;
  color: #035184;
  font-size: 13px;
}

.sessionDateItem {
  display: flex;
}

.sessionDateItemText {
  font-size: 15px;
}

.counterSessionValue {
  color: #ff852e;
  font-size: 14px;
}

.sessionDateItemImage {
  margin-left: 5px;
}

.counterSession {
  background: #ffecdf;
  padding: 4px;
  border-radius: 4px;
  margin-top: 8px;
}

.headerSessionCard {
  border-bottom: 1px solid #eaf0f6;
  padding-bottom: 10px;
}

.titleDoctorData {
  color: #616161;
  font-size: 14px;
}

.DoctorDataValue {
  font-size: 18px;
}

.imgBox {
  margin-left: 5px;
}

.preSessionBox {
  border: 1px solid #eaf0f6; /* sets all borders */
  border-right: 4px solid #5ad2a2; /* overrides right border */
  border-radius: 8px;
  padding: 8px 24px 16px 24px;
  /*width: 65%;*/
  margin-bottom: 30px;
}

.preSessionBadge {
  position: absolute;
  top: 13px;
  right: -20px;
  padding: 3px;
  color: white;
  background: #3cbe8b;
  font-size: 14px;
  width: 115px;
  text-align: center;
  transform: rotate(39deg);
}

.usedSession {
  /*background: #eee !important;*/
  /*background: #ddd !important;*/
  background: linear-gradient(
    45deg,
    #ddd 10%,
    rgba(240, 240, 240, 0.5)
  ) !important;
  /*box-shadow: inset 0 20px 30px -10px rgba(0,0,0,.1) !important;*/
}

.therapistImage {
}

.therapistImage img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.timeArea {
  /*background: #D8E9F8;*/
  height: auto;
  border-radius: 15px;
  padding: 5px 15px;
  font-size: 13px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.timeArea div {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.sessionCard {
  width: 100%;
  min-height: 130px;
  background: white;
  border-radius: 18px;
  padding: 25px;
  border: 1px solid #3cbe8b;
  box-shadow: 0px 1px 14px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.sessionCardTitle {
  font-size: 20px;
}

.sessionCardInfo {
  padding-right: 5px;
}

.statusLabel {
}

.actionArea {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: #3cbe8b;
}
</style>
